import { render, staticRenderFns } from "./PasswortZuruecksetzen.vue?vue&type=template&id=1eca6cfc&scoped=true"
import script from "./PasswortZuruecksetzen.vue?vue&type=script&lang=js"
export * from "./PasswortZuruecksetzen.vue?vue&type=script&lang=js"
import style0 from "./PasswortZuruecksetzen.vue?vue&type=style&index=0&id=1eca6cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca6cfc",
  null
  
)

export default component.exports